import { render, staticRenderFns } from "./TemplatePage.vue?vue&type=template&id=99cf32a8&"
import script from "./TemplatePage.vue?vue&type=script&lang=js&"
export * from "./TemplatePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports